// extracted by mini-css-extract-plugin
export default {"actionButton":"Aa14InboxTable_actionButton__SRHnm"};